import Suppliers from '../../components/GameManagement/Suppliers';

const SuppliersPage = () => {
	return <Suppliers />;
};

export default SuppliersPage;
